<template>
  <div class="home">
    <Heads />
    <div class="title">扫码上传</div>
    <div class="main">
      <div :height="height+70" style="width:100%;display:inline-block;">
        <div id="qrCode"></div>
        <div class="tips">请使用手机微信扫码</div>
        <div class="tips" style="color:#000;margin-top:20px;">扫码关注公众号即可上传影像胶片</div>
      </div>
    </div>
    <Footers />
  </div>
</template>

<script>
import Heads from "@/components/header.vue";
import Footers from "@/components/footervue.vue";
import QRCode from "qrcodejs2";
import { GetScanResult, GenerateShortUrl } from "@/api/upload";
export default {
  name: "home",
  data() {
    return {
      status: true,
      uuid: "",
      timeSender: null,
      UserId: "",
      width: 300,
      height: 300,
      url: ""
    };
  },
  components: {
    Heads,Footers
  },
  methods: {
    guid() {
      //生成uuid
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    qrcode() {
      if (window.innerWidth > 1400) {
        this.width = 220;
        this.height = 220;
      } else if (window.innerWidth > 900) {
        this.width = 170;
        this.height = 170;
      } else {
        this.width = 120;
        this.height = 120;
      }
      this.uuid = this.guid();
      var rurl =
        "https://film.rimag.com.cn/api/Auth/WxOauth?url=https://film.rimag.com.cn/success.html?qrcode=" +
        this.uuid;
      var url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2441b28e7640c165&redirect_uri=" +
        encodeURI(rurl) +
        "&response_type=code&scope=snsapi_base&state=GbkYin666&connect_redirect=1#wechat_redirect";
      this.generateShortUrl(url);
    },
    generateShortUrl(datas) {
      // var vm = this;
      GenerateShortUrl(datas)
        .then(response => {
          this.url = response.data;
          let qrcode = new QRCode("qrCode", {
            width: this.width,
            height: this.height, // 高度  [图片上传失败...(image-9ad77b-1525851843730)]
            text: "https://film.rimag.com.cn/#/ajax-301?code=" + this.url // 二维码内容
          });
        })
        .catch(error => {});
    },
    getScanResult() {
      // 定时获取用户扫码结果
      var vm = this;
      GetScanResult(this.uuid)
        .then(response => {
          // const data = response.data
          if (response.code == 20000) {
            if (response.data != null) {
              clearInterval(vm.timeSender);
              setTimeout(
                vm.$router.push({
                  path: "/upload",
                  query: { guid: vm.uuid, userId: response.data }
                }),
                1000
              );
            }
          }
        })
        .catch(error => {});
    }
  },

  beforeDestroy() {
    //清除定时器
    clearInterval(this.timer);
  },
  destroyed() {
    //清除定时器
    //clearInterval(this.timer);
  },

  mounted() {
    //调用
    this.qrcode(); // 画二维码
    this.$nextTick(function() {
      // 设置定时任务
      this.timeSender = setInterval(this.getScanResult, 5000);
    });
  }
};
</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #efeff4;
  .title {
    height: 80px;
    line-height: 80px;
    margin-left: 100px;
    font-size: 20px;
    color: #000;
    float: left;
  }
  .main {
    width: calc(100% - 160px);
    height: calc(100% - 240px);
    background: #fff;
    margin: 80px;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: -webkit-flex;
    #qrCode {
      display: inline-block;
      text-align: center;
    }
    .tips {
      height: 20px;
      color: #8e8e93;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
      font-family: PingFangSC-Regular;
    }
  }
}
</style>